import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["useSelector", "useDispatch"];
import * as React from 'react';
import { RootContext } from './context';
import { EActiveView } from '../../types/view';
import { UsernameAuthViewContainer } from '../UsernameAuthViewContainer';
import { PhoneAuthViewContainer } from '../PhoneAuthViewContainer';
import { PhoneAuthValidateSmsViewContainer } from '../PhoneAuthValidateSmsViewContainer';
import { PhoneAuthValidateCallViewContainer } from '../PhoneAuthValidateCallViewContainer';
import { RestoreViewContainer } from '../RestoreViewContainer';
import { EmailSentViewContainer } from '../EmailSentViewContainer';
import { TwoFactorAttemptsExhaustedViewContainer } from '../TwoFactorAttemptsExhaustedViewContainer';
import { TwoFactorWithEmailViewContainer } from '../TwoFactorWithEmailViewContainer';
import { TwoFactorWithPhoneViewContainer } from '../TwoFactorWithPhoneViewContainer';
import { TwoFactorWithPhoneValidateSmsViewContainer } from '../TwoFactorWithPhoneValidateSmsViewContainer';
import { TwoFactorWithPhoneValidateCallViewContainer } from '../TwoFactorWithPhoneValidateCallViewContainer';
import { ConfirmPhoneViewContainer } from '../ConfirmPhoneViewContainer';
import { SocialCreateViewContainer } from '../SocialCreateViewContainer';
import { SocialMergeViewContainer } from '../SocialMergeViewContainer';
import { AccountSelectView } from '../AccountSelectView';
import { ConfirmAccountViewContainer } from '../ConfirmAccountView/connect';
import { TokenExpiredErrorViewContainer } from '../TokenExpiredErrorView/connect';
import { AccountSelectErrorViewContainer } from '../AccountSelectErrorView/connect';
import { AgreementViewContainer } from '../AgreementViewContainer';
import { RememberedAccountsViewContainer } from '../RememberedAccountsViewContainer';
import { ErrorBoundary } from '../../components/ErrorBoundary';
import { selectActiveView } from '../../selectors/view';
import { setAutoFocusDisabled } from '../../actions/autoFocusDisabled';
export var RootContainer = function RootContainer(_ref) {
  var useSelector = _ref.useSelector,
    useDispatch = _ref.useDispatch,
    props = _objectWithoutProperties(_ref, _excluded);
  var dispatch = useDispatch();
  var activeView = useSelector(selectActiveView);
  React.useEffect(function () {
    /**
     * Отключенный автофокус должен быть лишь при первой загрузке виджета.
     * При работе с виджетом автофокус на полях виджета авторизации - ожидаемое поведение.
     */
    dispatch(setAutoFocusDisabled(false));
  }, []);
  var ViewContainer = React.useMemo(function () {
    switch (activeView) {
      case EActiveView.AuthenticationRegistration:
        return UsernameAuthViewContainer;
      case EActiveView.Agreement:
        return AgreementViewContainer;
      case EActiveView.RememberedAccountsSelect:
        return RememberedAccountsViewContainer;
      case EActiveView.PhoneAuth:
        return PhoneAuthViewContainer;
      case EActiveView.PhoneAuthValidateSms:
        return PhoneAuthValidateSmsViewContainer;
      case EActiveView.PhoneAuthValidateCall:
        return PhoneAuthValidateCallViewContainer;
      case EActiveView.AccountSelect:
        return AccountSelectView;
      case EActiveView.ConfirmSelectedAccount:
        return ConfirmAccountViewContainer;
      case EActiveView.TokenExpiredError:
        return TokenExpiredErrorViewContainer;
      case EActiveView.AccountSelectError:
        return AccountSelectErrorViewContainer;
      case EActiveView.Restore:
        return RestoreViewContainer;
      case EActiveView.TwoFactorWithPhone:
        return TwoFactorWithPhoneViewContainer;
      case EActiveView.TwoFactorPhoneValidateSms:
        return TwoFactorWithPhoneValidateSmsViewContainer;
      case EActiveView.TwoFactorPhoneValidateCall:
        return TwoFactorWithPhoneValidateCallViewContainer;
      case EActiveView.TwoFactorAttemptsExhausted:
        return TwoFactorAttemptsExhaustedViewContainer;
      case EActiveView.TwoFactorWithEmail:
        return TwoFactorWithEmailViewContainer;
      case EActiveView.ConfirmPhone:
        return ConfirmPhoneViewContainer;
      case EActiveView.EmailSent:
        return EmailSentViewContainer;
      case EActiveView.SocialCreate:
        return SocialCreateViewContainer;
      case EActiveView.SocialMerge:
        return SocialMergeViewContainer;
      default:
        return null;
    }
  }, [activeView]);
  return /*#__PURE__*/React.createElement(RootContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    logger: props.logger
  }, ViewContainer && /*#__PURE__*/React.createElement(ViewContainer, null)));
};